module.exports = __webpack_public_path__ + "static/img/home_carousel_1new.19d9f95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/home_carousel_1new.jpg
// module id = hmcy
// module chunks = 15